import { myAccountViewStyles } from "@insite/content-library/Widgets/MyAccount/MyAccountView";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

myAccountViewStyles.quickLinksGridItem = {
    width: [12, 12, 2, 2, 2],
    css: css`
        span {
            color: ${getColor("primary")} !important;
        }
    `,
};

myAccountViewStyles.mainSectionGridItem = {
    width: [12, 12, 10, 10, 10],
};
